module.exports = __webpack_public_path__ + "static/assets/70cd451cecdf0038e7ee5319356790e6.svg";